import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { colors, breakpoints, spacing, font } from '../..';
import letterSpacing from '../../letterSpacing';
export default {
  name: 'fanta',
  // html: {
  //     fontSize: "" // This can be useful in case of internationalization
  // },
  // dir: "",
  spacing: {
    xxs: spacing.px4,
    xs: spacing.px8,
    sm: spacing.px12,
    md: spacing.px16,
    lg: spacing.px24,
    xl: spacing.px32,
    xl2: spacing.px40,
    xl3: spacing.px48,
    xl4: spacing.px64,
    xl5: spacing.px80,
    xl6: spacing.px96,
    xl7: spacing.px112,
    xl8: spacing.px128,
    xl9: spacing.px144,
    xl10: spacing.px160
  },
  font: {
    family: font.family.aspira,
    size: {
      xxs: font.size.px12,
      xs: font.size.px14,
      sm: font.size.px16,
      md: font.size.px18,
      lg: font.size.px20,
      lg2: font.size.px22,
      lg3: font.size.px26,
      lg4: font.size.px28,
      lg5: font.size.px32,
      xl: font.size.px36,
      xl2: font.size.px42,
      xl3: font.size.px46,
      xl4: font.size.px52,
      xl5: font.size.px66,
      xl6: font.size.px74
    },
    weight: _objectSpread({}, font.weight),
    lineHeight: {
      xs: 1.1,
      sm: 1.3,
      md: 1.5,
      lg: 1.7
    },
    letterSpacing: {
      xs: letterSpacing.px_m_0p75,
      sm: letterSpacing.px_0,
      md: letterSpacing.px_0p25,
      lg: letterSpacing.px_0p35,
      xl: letterSpacing.px_1,
      xxl: letterSpacing.px_1p25
    }
  },
  breakpoints: {
    sm: breakpoints.sm,
    md: breakpoints.md,
    lg: breakpoints.lg,
    xl: breakpoints.xl,
    xxl: {
      cols: 12,
      gap: '1.5rem',
      min: '1200px',
      max: '2000000px',
      marginLeftRight: spacing.px24
    }
  },
  boxShadow: {
    elevation100: '0 1px 2px 0 rgba(13, 13, 15, 0.3), 0 1px 3px 1px rgba(13, 13, 15, 0.15)',
    elevation200: '0 1px 2px 0 rgba(13, 13, 15, 0.3), 0 2px 6px 2px rgba(13, 13, 15, 0.15)',
    elevation300: '0 1px 3px 0 rgba(13, 13, 15, 0.3), 0 4px 8px 3px rgba(13, 13, 15, 0.15)',
    elevation400: '0 2px 3px 0 rgba(13, 13, 15, 0.3), 0 6px 10px 4px rgba(13, 13, 15, 0.15)',
    elevation500: '0 4px 4px 0 rgba(13, 13, 15, 0.3), 0 8px 12px 6px rgba(13, 13, 15, 0.15)'
  },
  textShadow: {
    "default": "0 0 0.5em ".concat(colors.grey950)
  },
  gradient: {
    light100: "linear-gradient(180deg, ".concat(colors.white, " 0%, ").concat(colors.grey100, " 100%)")
  },
  radius: {
    xs: '2px',
    sm: '4px',
    md: '8px',
    lg: '16px',
    circle: '50%'
  },
  colors: {
    primary: {
      dark: colors.orange400,
      light: colors.white
    },
    secondary: {
      lighter: colors.grey050,
      light: colors.manila100,
      dark: colors.violet600,
      darker: colors.grey800
    },
    error: {
      dark: colors.red700,
      light: colors.red100
    },
    success: {
      dark: colors.green700,
      light: colors.green100
    },
    alert: {
      dark: colors.solar700,
      light: colors.solar100
    },
    info: {
      dark: colors.blue700,
      light: colors.blue100
    },
    accent: {
      dark: colors.violet500,
      light: colors.violet100
    },
    border: {
      light100: colors.grey100,
      light200: colors.grey200,
      light300: colors.grey300,
      medium400: colors.grey400,
      medium500: colors.grey500,
      medium600: colors.grey600,
      dark700: colors.grey700,
      dark800: colors.grey800,
      dark900: colors.grey900,

      /** @deprecated */
      medium700: colors.grey700,

      /** @deprecated */
      dark: colors.grey800
    },

    /** Grey 950 - 50% alpha */
    backdrop: 'rgba(36, 32, 53, 0.5)'
  },
  zIndex: {
    xs: 100,
    sm: 200,
    md: 300,
    lg: 350,
    xl: 400,
    xxl: 500,
    xl9: 999999
  }
};